<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        仓库基础信息
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.编辑"
            class="g-form-section-search operate__item"
            title="编辑"
            icon="el-icon-plus"
            @click="$router.push('/baseStorageEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            v-if="operationSuper.导出"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="el-icon-search"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.storageName">
            <el-input
              v-model="slotForms.forms.storageName"
              placeholder="冷库名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.regisArea">
            <e6-city
              ref="e6City"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              class="e6-city"
              @selected="citySelect"
            ></e6-city>
          </el-form-item>
          <!--<el-form-item prop="forms.countyNameId">-->
          <!--<dict-select-->
          <!--v-model="slotForms.forms.countyNameId"-->
          <!--placeholder="所属区(县)"-->
          <!--:pkey="'county_name'"-->
          <!--&gt;</dict-select>-->
          <!--</el-form-item>-->
          <el-form-item prop="forms.coldStorageType">
            <dict-select
              v-model="slotForms.forms.coldStorageType"
              placeholder="仓库类型"
              :pkey="'cold_storage_type'"
              clearable
            ></dict-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="170"
          align="center"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <el-table-column label="区位数量" prop="storageAreaNum">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.storageAreaNum > 0"
              :to="{
                path: '/baseStorageAreaList',
                query: { storageAreaIds: scope.row.storageAreaIds },
              }"
              style="color: #0000ff"
            >
              {{ scope.row.storageAreaNum }}
            </router-link>
            <span v-else>{{ scope.row.storageAreaNum }}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" align="center" label="操作" width="120">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.编辑"
              :to="{
                path: '/baseStorageEdit',
                query: {
                  pageType: '2',
                  id: scope.row.storageId,
                  provinceId: scope.row.provinceId,
                },
              }"
              >编辑</router-link
            >&nbsp;
            <el-button
              v-if="operationSuper.删除"
              @click="deleteRow(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import e6City from "e6city";
import { DeleteStorageInfoByIds } from "@/api/base/storage";
import { mapActions } from "vuex";
import { mergeFormExtend } from "_private/utils/merge";
import listInit from "@/mixins/listInit";
import operationManage from "_private/mixins/operationManage";
export default {
  components: { e6City },
  mixins: [operationManage, listInit],
  data() {
    return {
      isSearch: false,
      formExtend: {
        forms: {
          comparyName: "",
          storageName: "",
          countyNameId: "",
          // provinceName: $GLOBAL_CONFIG.e6City.provinceName,
          provinceName: "",
          // cityName: $GLOBAL_CONFIG.e6City.cityName,
          cityName: "",
          countyName: "",
          regisArea: "",
          coldStorageType: "",
        },
        extends: [],
      },
      formsExtend: [],
      columSetVisible: false,
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      // 请求表格数据
      tableDataUrl: "/base/storage/findByPage",
      //导出URL
      exportUrl: "/base/storage/exportStorageList?",
      errMess: "",
    };
  },

  created() {
    if (this.$route.query.storageType) {
      this.formExtend.forms.coldStorageType = Number(this.$route.query.storageType);
    }
    this.setSearchFormIsOpenAct();
    this.initPage();
  },
  mounted() {
    let comparyName = this.$route.query.comparyName;
    if (comparyName) {
      this.formExtend.forms.comparyName = comparyName;
    }
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 删除行
    deleteRow({ row }) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.tableLoading = true;

          const { code, message } = await DeleteStorageInfoByIds({
            ids: row.storageId,
          });

          this.tableLoading = false;

          if (code === 1) {
            this.successMessage("删除成功", () => {
              this.handleCurrentChange(1);
            });
          } else {
            this.errorMessage(message || "删除失败，请重试");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "香港") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "台湾省") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
      }
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize,
      });
    },

    // 重置
    handleResetForm() {
      this.$refs.e6City.clearCity();
      this.formExtend.forms.provinceName = "";
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.countyName = "";
    },

    handleExportClick() {
      let param = "";
      param += "&comparyName=" + this.formExtend.forms.comparyName;
      param += "&storageName=" + this.formExtend.forms.storageName;
      param += "&countyNameId=" + this.formExtend.forms.countyNameId;
      param += "&provinceName=" + this.formExtend.forms.provinceName;
      param += "&cityName=" + this.formExtend.forms.cityName;
      param += "&countyName=" + this.formExtend.forms.countyName;
      document.location.href = this.exportUrl + param;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
